module.exports = __webpack_public_path__ + "img/member-verify-bg-3.fe4ef352.png";